import type { ReactNode } from "react";
import Box from "../Box";

type Props = {
	renderTopBar?: () => ReactNode;
	renderBottomBar?: () => ReactNode;
	children: ReactNode;
};

const SessionShell = ({ renderTopBar, renderBottomBar, children }: Props) => {
	return (
		<Box flex={1}>
			{renderTopBar?.()}
			<Box flex={1}>{children}</Box>
			{renderBottomBar?.()}
		</Box>
	);
};

export default SessionShell;
